/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, Fragment, useMemo, useCallback, useEffect } from "react";

// antd:
import { Radio, Form } from "antd";
import type { RadioChangeEvent } from "antd";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// import DivE from "../react/DivE.tsx";
// Redux-hooks:
import { useAppSelector, useAppDispatch } from "../../libs/redux-hooks.ts";
// Reducers:
import { getLng, getDict, getTheme, getAppState, getUser, changeAppState, onChangeTheme, onChangeCompact, onChangeLng, onChangeShowDesktopIconsTitle, getSafePtr } from "../../libs/reducer.ts"; // getAppState
// My functions
import fnc from "../../libs/fnc.ts";
// Types:
// import type {TelementState} from "../../types/uiapp.d.ts";
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";
import type {Tpermissions} from "../../types/easyTypes.ts";

// const { Title, Text, Link, Paragraph } = Typography;

const { rz } = window;

type Toptions = {
  buttonStyle?:"outline" | "solid",
  optionType?:"default" | "button",
  size:"large" | "middle" | "small"
};

const RZradio:FC<TuniversalElementProps> = ({attributes, children}) => {
  RZradio.displayName = "Radio";
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUser);
  const dct = useAppSelector(getDict);
  const lng = useAppSelector(getLng);
  const theme = useAppSelector(getTheme);
  const safe = useAppSelector(getSafePtr);
  const rlng = (lng === "en" ? "ru" : "en");

  const {rootAttributes, key, fullPath, content, type} = attributes; // onClick, onChange, onRightClick, onHover, onLoad
  const appState = useAppSelector(getAppState(rootAttributes.key)), elState = appState[fullPath]; // value, visible, disabled, loading, userStyle, userClass
  const {color, backgroundColor} = elState.attributes;
  const rootNamespace = useMemo(() => (window[rootAttributes?.key || rz.strMakeID(24)]), [rootAttributes?.key]);
  const isParentForm = useMemo(() => {
    const parentPath = rz.strParentFolderName(fullPath || ""), parentState = appState[parentPath];
    return Boolean(parentState.name === "form");
  }, [appState, fullPath]);

  const permissions = useMemo<Tpermissions>(() => (fnc.checkPermissions(user, attributes)), [user, attributes]);

  const optionsType = useMemo<Toptions>(() => {
    const typ:Toptions = {size: "middle", optionType: "default", buttonStyle: "outline"};
    (type || "").toLowerCase().replace((/(\s+|_|\|)/igm), " ").split(" ").forEach((tt) => {
      if (~["small", "middle", "large"].indexOf(tt)) { typ.size = tt }
      else if (~["button"].indexOf(tt)) { typ.optionType = tt }
      else if (~["outline", "solid"].indexOf(tt)) { typ.buttonStyle = tt }
    });

    if (attributes?.size) { typ.size = attributes.size }
    if (attributes?.optionType) { typ.optionType = attributes.optionType }
    if (attributes?.buttonStyle) { typ.buttonStyle = attributes.buttonStyle }
    return typ;
  }, [type, attributes]);

  const clsu = useMemo<Array<string>>(() => {
    const userClss = rz.objClone(elState?.userClass || []);
    // if ((elState?.disabled || permissions.disabled === true) && !~userClss.indexOf("uk-disabled")) { userClss.push("uk-disabled") }
    return userClss;
  }, [elState?.userClass]);

  const styl = useMemo<CSS.Properties>(() => {
    const est = {...elState.userStyle};
    if ((elState?.visible === false || permissions.visible === false) && est.display !== "none") { est.display = "none" }
    else if ((elState?.visible === true && permissions.visible !== false) && est.display === "none") { est.display = undefined }
    let clr:string; const allc = (color || "").split("|"); if (allc.length > 1) { clr = (theme === "dark" ? allc[1] : allc[0]) } else { clr = allc[0] }
    if (!est?.color && clr) { est.color = clr }
    let bclr:string; const allb = (backgroundColor || "").split("|"); if (allb.length > 1) { bclr = (theme === "dark" ? allb[1] : allb[0]) } else { bclr = allb[0] }
    if (!est?.backgroundColor && bclr) { est.backgroundColor = bclr }
    return est;
  }, [elState.userStyle, elState?.visible, color, backgroundColor, theme, permissions]);

  const plainOptions = useMemo<Array<{value:string, label:string, disabled:boolean}>>(() => {
    if (elState.items && elState.items.length) {
      return elState.items.map((ch, c) => {
        const perm1 = fnc.checkPermissions(user, {...ch?.attributes, rootAttributes: {key: rootAttributes.key}});
        return {
          value: (rz.isString(ch) ? ch : (ch.value || ch.key || (key + "-" + c))),
          label: (rz.isString(ch) ? ch : (ch["title_" + lng] || ch.title || ch["title_" + rlng] || ch["label_" + lng] || ch.label || ch["label_" + rlng] || "")),
          disabled: (perm1.disabled === true || appState[ch.fullPath]?.disabled)
        }
      });
    }
    if (content && content.length) {
      return content.map((ch, c) => {
        const perm1 = fnc.checkPermissions(user, {...ch?.attributes, rootAttributes: {key: rootAttributes.key}});
        return {
          value: (rz.isString(ch) ? ch : (ch.attributes.value || ch.attributes.key || (key + "-" + c))),
          label: (rz.isString(ch) ? ch : (ch.attributes["title_" + lng] || ch.attributes.title || ch.attributes["title_" + rlng] || ch.attributes["label_" + lng] || ch.attributes.label || ch.attributes["label_" + rlng] || "")),
          disabled: (perm1.disabled === true || appState[ch.fullPath]?.disabled)
        }
      });
    }
    return [];
  }, [appState, content, elState.items, key, lng, rlng, rootAttributes.key, user]);

  // eslint-disable-next-line react-hooks/exhaustive-deps, max-len
  const title = useMemo<string | undefined>(() => (elState.attributes["title_" + lng] || elState.attributes.title || elState.attributes["title_" + rlng] || attributes["title_" + lng] || attributes.title || attributes["title_" + rlng]), [elState.attributes, attributes, lng]);
  // eslint-disable-next-line max-len, react-hooks/exhaustive-deps
  const title2 = useMemo<string | undefined>(() => (elState?.attributes["title2_" + lng] || elState?.attributes.title2 || elState?.attributes["title2_" + rlng] || attributes["title2_" + lng] || attributes.title2 || attributes["title2_" + rlng]), [elState?.attributes, attributes, lng]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const tooltip = useMemo<string | undefined>(() => (elState.attributes["tooltip_" + lng] || elState.attributes.tooltip || elState.attributes["tooltip_" + rlng]), [elState.attributes, lng]);

  // Единообразно применяем результат пользовательского onChange:
  // локальный state компонента и возможные изменения глобального state приложения.
  const applyHandlerResult = useCallback((ret:any) => {
    if (rz.isUndefinedOrNull(ret)) { return }
    if (ret && ret.err) { console.log(ret.err) }
    if (ret && ret?.state?.fullPath && ret?.state?.newState) {
      dispatch(changeAppState({appkey: rootAttributes.key, fullPath: ret.state.fullPath, newState: ret.state.newState}));
    }
    if (ret && ret?.globalState) {
      if (ret.globalState.lng) { dispatch(onChangeLng(ret.globalState.lng, true)) }
      if (!rz.isUndefinedOrNull(ret.globalState.theme)) { dispatch(onChangeTheme(ret.globalState.theme, true)) }
      if (!rz.isUndefinedOrNull(ret.globalState.compact)) { dispatch(onChangeCompact(ret.globalState.compact, true)) }
      if (!rz.isUndefinedOrNull(ret.globalState.showDesktopIconsTitle)) { dispatch(onChangeShowDesktopIconsTitle(ret.globalState.showDesktopIconsTitle, true)) }
    }
  }, [dispatch, rootAttributes.key]);

  const onChange = useCallback((event:RadioChangeEvent) => {
    const nextValue = event.target.value;
    const handlerName = attributes.onChange || attributes.onchange;
    if (fnc.config?.isDev) console.log({action: "<Option key='" + key + "'> -> onChange()", value: nextValue});
    // Сначала сразу сохраняем выбранное значение в Redux state самого Radio.
    dispatch(changeAppState({appkey: rootAttributes.key, fullPath, newState: {...elState, value: nextValue}}));
    if (rootNamespace && handlerName && rz.isFunction(rootNamespace[handlerName])) {
      const ret = rootNamespace[handlerName]({appkey: rootAttributes.key, attributes, key, user, lng, dct, value: nextValue, safe});
      // Поддерживаем async-обработчик: раньше Promise проверялся не у результата вызова функции.
      if (rz.isPromise(ret)) {
        ret.then((resolved) => {
          applyHandlerResult(resolved);
        });
        return;
      }
      applyHandlerResult(ret);
    }
  }, [key, dispatch, rootAttributes.key, fullPath, elState, rootNamespace, attributes, user, lng, dct, safe, applyHandlerResult]);

  // Безопасный fallback: берем value из state, затем из attributes,
  // и только потом первый option, если он вообще существует.
  const groupValue = useMemo(() => (elState.value ?? attributes.value ?? plainOptions[0]?.value), [elState.value, attributes.value, plainOptions]);

  const wrapperForm = useCallback((mainComponent:React.ReactNode) => {
    if (isParentForm) {
      const frmItemProps:{[key:string]:any} = {
        key: key + "-formitem", label: (<span className="rz-txt-std">{title2}</span>), className: "rz-width-expand",
        style: ((elState?.visible === false || permissions.visible === false) ? {display: "none"} : undefined)
      };
      // eslint-disable-next-line max-len
      return (
        <Form.Item {...frmItemProps}>
          {mainComponent}
        </Form.Item>
      )
    }
    return mainComponent;
  }, [isParentForm, title2, key, elState?.visible, permissions.visible]);

  return (
    wrapperForm(
      <Radio.Group key={key} className={clsu.join(" ")} style={styl} uk-tooltip={tooltip}
        options={plainOptions}
        value={groupValue}
        // defaultValue={elState?.value || attributes?.value || plainOptions[0].value}
        optionType={optionsType.optionType}
        buttonStyle={optionsType.buttonStyle}
        size={optionsType.size}
        onChange={onChange}
        disabled={elState?.disabled || permissions.disabled === true}
      />
    )
  );
}

export default RZradio;
/* eslint-enable @typescript-eslint/no-unused-vars */
